import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get, APIError } from '../services/crud'
import { IDiscountCode } from './typings'
import { ISearchResponse } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.discountCode}`

export const getDiscountCodes = createAsyncThunk<
  IDiscountCode[],
  void,
  { rejectValue: APIError }
>('discountCode/get', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) {
    const result: ISearchResponse<IDiscountCode> = await response.json()
    return result.items
  }
  return thunkApi.rejectWithValue(await response.json())
})
